import { MedicationEntryType } from "model/medication-entry.model";

/** ---- Dispatch Types ---- */
export const LOAD_ACTIVE_MEDICATION_START = "LOAD_ACTIVE_MEDICATION_START";
export const LOAD_ACTIVE_MEDICATION_SUCCESS = "LOAD_ACTIVE_MEDICATION_SUCCESS";
export const LOAD_ACTIVE_MEDICATION_ERROR = "LOAD_ACTIVE_MEDICATION_ERROR";
export const SELECT_ACTIVE_MEDICATION = "SELECT_ACTIVE_MEDICATION";
export const EDIT_ACTIVE_MEDICATION = "EDIT_ACTIVE_MEDICATION";
export const RESET_ACTIVE_MEDICATION = "RESET_ACTIVE_MEDICATION";
export const TOGGLE_SELECT_MEDICATION = "TOGGLE_SELECT_MEDICATION";

export const NEW_MEDICATION_PREFILL_START = "NEW_MEDICATION_PREFILL_START";
export const NEW_MEDICATION_PREFILL_SUCCESS = "NEW_MEDICATION_PREFILL_SUCCESS";
export const NEW_MEDICATION_PREFILL_ERROR = "NEW_MEDICATION_PREFILL_ERROR";

export const REPEAT_MED_PREFILL_START = "REPEAT_MED_PREFILL_START";
export const REPEAT_MED_PREFILL_SUCCESS = "REPEAT_MED_PREFILL_SUCCESS";
export const REPEAT_MED_PREFILL_ERROR = "REPEAT_MED_PREFILL_ERROR";

export const CREATE_MEDICATION_SUCCESS = "CREATE_MEDICATION_SUCCESS";
export const CREATE_MEDICATION_START = "CREATE_MEDICATION_START";

export const STOP_MEDICATION_START = "STOP_MEDICATION_START";
export const STOP_MEDICATION_SUCCESS = "STOP_MEDICATION_SUCCESS";

export const REMOVE_MEDICATION = "REMOVE_MEDICATION";

/** ---- Dispatch Interfaces ---- */
interface RemoveMedication {
  type: typeof REMOVE_MEDICATION;
  payload: MedicationEntryType;
}

interface CreateMedicationSuccess {
  type: typeof CREATE_MEDICATION_SUCCESS;
  payload: Array<MedicationEntryType>;
}

interface RepeatMedPrefillStart {
  type: typeof REPEAT_MED_PREFILL_START;
  payload: MedicationEntryType;
}

interface RepeatMedPrefillSuccess {
  type: typeof REPEAT_MED_PREFILL_SUCCESS;
  payload: { old: MedicationEntryType; new: MedicationEntryType };
}

interface RepeatMedPrefillError {
  type: typeof REPEAT_MED_PREFILL_ERROR;
}

interface NewMedicationPreFillStart {
  type: typeof NEW_MEDICATION_PREFILL_START;
}

interface NewMedicationPreFillSuccess {
  type: typeof NEW_MEDICATION_PREFILL_SUCCESS;
  payload: MedicationEntryType;
}

interface NewMedicationPreFillError {
  type: typeof NEW_MEDICATION_PREFILL_ERROR;
}

interface CreateMedicationStart {
  type: typeof CREATE_MEDICATION_START;
  payload: Array<MedicationEntryType>;
}

interface StopMedicationStart {
  type: typeof STOP_MEDICATION_START;
  payload: Array<MedicationEntryType>;
}

interface StopMedicationSuccess {
  type: typeof STOP_MEDICATION_SUCCESS;
  payload: { old: Array<MedicationEntryType>; new: Array<MedicationEntryType> };
}

interface LoadActiveMedicationStartAction {
  type: typeof LOAD_ACTIVE_MEDICATION_START;
}

interface LoadActiveMedicationSuccessAction {
  type: typeof LOAD_ACTIVE_MEDICATION_SUCCESS;
  payload: MedicationEntryType[];
}

interface LoadActiveMedicationErrorAction {
  type: typeof LOAD_ACTIVE_MEDICATION_ERROR;
}

interface SelectActiveMedication {
  type: typeof SELECT_ACTIVE_MEDICATION;
  payload: MedicationEntryType;
}

interface EditActiveMedication {
  type: typeof EDIT_ACTIVE_MEDICATION;
  payload: MedicationEntryType;
}

interface ToggleSelectMedication {
  type: typeof TOGGLE_SELECT_MEDICATION;
  payload: MedicationEntryType;
}

interface ResetActiveMedication {
  type: typeof RESET_ACTIVE_MEDICATION;
}

export type MedicationAction =
  | RemoveMedication
  | StopMedicationStart
  | StopMedicationSuccess
  | CreateMedicationSuccess
  | RepeatMedPrefillStart
  | RepeatMedPrefillSuccess
  | RepeatMedPrefillError
  | NewMedicationPreFillStart
  | NewMedicationPreFillSuccess
  | NewMedicationPreFillError
  | CreateMedicationStart
  | LoadActiveMedicationStartAction
  | LoadActiveMedicationSuccessAction
  | LoadActiveMedicationErrorAction
  | SelectActiveMedication
  | EditActiveMedication
  | ToggleSelectMedication
  | ResetActiveMedication;
